
export const crossAssetTrendsContainerId = 'cross-analysis-trends-chart';
